import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ESpinner from 'components/others/Spinner';
import SpinnerBlock from 'components/others/SpinnerBlock';
import { useEmailsDirectory } from '../context/EmailsDirProvider';
import EmailsTableBody from './EmailsTableBody';

const EmailsTable = ({ others = false }: { others?: boolean }) => {
    const { t } = useTranslation('EmailsDir');
    const model = useEmailsDirectory();
    const loading = others ? model.entriesLoading : model.clientsLoading;
    const error = others ? model.entriesError : model.clientError;
    if (loading) return <ESpinner />;
    return (
        <div className="position-relative">
            {error && <div role="alert" className="alert alert-danger">{t('error')}</div>}
            <SpinnerBlock show={model.busy} onlyBlur={true} />
            <div className="crm-table-wrap table-responsive">
                <Table className={`emails-dir-table ${others ? 'emails-dir-table-others' : 'emails-dir-table-clients'}`}>
                    <thead><tr>
                        <td className="head-check"><span className="visually-hidden">{t('choose')}</span></td>
                        <td className="head-name">{t(others ? 'name' : 'client')}</td>
                        <td className="head-email">{t('email')}</td>
                        {others && <td className="head-username">{t('author')}</td>}
                        {others && <td className="head-action text-end">{t('actions')}</td>}
                    </tr></thead>
                    <EmailsTableBody others={others} />
                </Table>
            </div>
        </div>
    );
};

export default EmailsTable;
